<p-dialog #dialog styleClass="invoiceUploadDialog"
          modal="true"
          header="Invoice Upload"
          [(visible)]="displayDialog"
          appendTo="body"
          (onHide)="onClose()"
          closeOnEscape="false"
          closeable="false"
          [maximizable]="true"
          [style]="style">

  <div class="p-grid p-align-stretch widget-container">

    <div class="p-col-fixed left-pane">
      <form [formGroup]="form"
            class="validated-form admin-form">

        <p-accordion [multiple]="true">

          <p-accordionTab header="Document Details" [selected]="documentDetailsExpanded">

            <mojo-input-field label="Account for:" *ngIf="showAccounts">
              <p-dropdown id="accountFor"
                          hideDropdownOnScroll
                          [options]="accounts"
                          optionLabel="CreditorName"
                          dataKey="Uri"
                          formControlName="accountFor"
                          appendTo="body"
                          [filter]="true"
                          placeholder="Select…"
                          [style]="{'width': '100%'}"
              >
              </p-dropdown>
            </mojo-input-field>

            <mojo-input-field label="Purchase Order / Contract:" *ngIf="worksAddonEnabled">
              <p-dropdown *ngIf="worksAddonEnabled"
                          id="purchaseOrderOrContractId"
                          hideDropdownOnScroll
                          [options]="purchaseOrdersAndContracts | async"
                          group="true"
                          optionGroupChildren="Items"
                          optionLabel="Name"
                          formControlName="purchaseOrderOrContractId"
                          optionGroupLabel="Name"
                          appendTo="body"
                          [filter]="true"
                          placeholder="Select…"
                          [style]="{'width': '100%'}"></p-dropdown>
            </mojo-input-field>

            <mojo-input-field label="From date:" *ngIf="isContractSelected | async">
              <p-calendar #docDate
                          mojoUseUtc
                          formControlName="fromDate"
                          dateFormat="dd/mm/yy"
                          placeholder="dd/mm/yyyy"
                          yearRange="1753:9999"
                          [style]="{'width': '100%'}">
              </p-calendar>
            </mojo-input-field>

            <mojo-input-field label="To date:" *ngIf="isContractSelected | async">
              <p-calendar #docDate
                          mojoUseUtc
                          formControlName="toDate"
                          dateFormat="dd/mm/yy"
                          placeholder="dd/mm/yyyy"
                          yearRange="1753:9999"
                          [style]="{'width': '100%'}">
              </p-calendar>
            </mojo-input-field>


            <mojo-input-field label="Document type:">
              <p-dropdown hideDropdownOnScroll
                          [options]="availableDocumentTypes"
                          formControlName="documentType"
                          appendTo="body"
                          placeholder="Select…"
                          [style]="{'width': '100%'}">
              </p-dropdown>
            </mojo-input-field>

            <mojo-input-field label="Document date:">
              <p-calendar #docDate
                          mojoUseUtc
                          formControlName="documentDate"
                          [defaultDate]="defaultDate"
                          dateFormat="dd/mm/yy"
                          placeholder="dd/mm/yyyy"
                          yearRange="1753:9999"
                          [style]="{'width': '100%'}">
              </p-calendar>
            </mojo-input-field>

            <mojo-input-field label="Document reference:">
              <input type="text"
                     maxlength="35"
                     formControlName="documentReference"
                     placeholder="The Invoice / Credit No."
                     pInputText/>

            </mojo-input-field>

          </p-accordionTab>

          <p-accordionTab [header]="billingAmountHeader | async" [selected]="billingAmountExpanded">

            <mojo-input-field label="Net amount:">

              <input type="text"
                     mojoNumericInput
                     formControlName="netAmount"
                     placeholder="0.00"
                     [min]="0"
                     [max]="maxNumeric"
                     pInputText>

            </mojo-input-field>

            <mojo-input-field label="VAT rate:">
              <p-dropdown hideDropdownOnScroll
                          [options]="vatRates"
                          optionLabel="Description"
                          dataKey="Code"
                          formControlName="vatRate"
                          appendTo="body"
                          placeholder="Select..."
                          [style]="{'width': '100%'}">
              </p-dropdown>
            </mojo-input-field>

            <mojo-input-field label="VAT amount:">

              <input type="text"
                     mojoNumericInput
                     formControlName="vatAmount"
                     placeholder="auto-calculate"
                     [min]="0"
                     [max]="maxNumeric"
                     pInputText/>

            </mojo-input-field>


            <mojo-input-field label="Gross amount:">
              <input type="text"
                     mojoNumericInput
                     formControlName="grossAmount"
                     readonly="readonly"
                     placeholder="0.00"
                     [min]="0"
                     [max]="maxNumeric"
                     pInputText/>
            </mojo-input-field>

          </p-accordionTab>

          <p-accordionTab header="Service Details" [selected]="billingDetailsExpanded">

            <mojo-input-field label="Property address:">
              <textarea maxlength="320" formControlName="billingAddress" pInputTextarea></textarea>
            </mojo-input-field>

            <mojo-input-field label="Services rendered:">
              <textarea maxlength="40" formControlName="servicesRendered" pInputTextarea></textarea>
            </mojo-input-field>

          </p-accordionTab>

          <p-accordionTab header="Additional Documents" [selected]="additionalDocumentsExpanded"
                          class="additional-docs-section">
            <mojo-additional-docs
              #additionalDocs
              chooseLabel="Add"
              (upload)="onFileUpload($event)"
              (deleteUpload)="onDeleteUpload($event)">
            </mojo-additional-docs>
          </p-accordionTab>

        </p-accordion>

      </form>
    </div>

    <!-- Pdf area -->
    <div class="p-col pdf-view-wrapper">
      <ngx-extended-pdf-viewer *ngIf="pdfSource"
        [src]="pdfSource"
        [showFindButton]="false"
        [showDownloadButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showSecondaryToolbarButton]="false"></ngx-extended-pdf-viewer>
    </div>

  </div>

  <p-footer>
    <button [disabled]="!canSend()" pButton label="Send" (click)="send()"></button>
  </p-footer>

</p-dialog>
